import DatosComunicacionConsulta from './DatosComunicacionConsulta';

export default DatosComunicacionConsulta;
